'use client';
import dayjs from 'dayjs';
import { useFriendlyViewPort } from '../../../hooks/useFriendlyViewPort';
import EventOverviewComponent from '../../../components/Event/EventOverviewComponent';
import { useViewportSizeTracking } from '../../../hooks/useViewportSizeTracking';
import eventVal from './[slug]/page.val';
import { useVal } from '../../../val/val.client';
import { useEffect, useState } from 'react';
import { getAllActiveEvents } from '../../../utils/getAllActiveEvents';
import eventSeriesVal from '../../../settings/eventSeries.val';

const Event = () => {
  const eventsBySlug = getAllActiveEvents(
    useVal(eventVal),
    useVal(eventSeriesVal)
  );

  const [currentDate, setCurrentDate] = useState<Date>();
  useEffect(() => {
    setCurrentDate(new Date());
  }, []);
  const events = Object.entries(eventsBySlug)
    /* .filter(([, event]) => event.series !== 'fest') */ //TODO find out why this triggers hydration error
    .map(([slug, event]) => ({
      slug,
      ...event,
    }));
  const previousEvents = events
    .filter(
      (event) =>
        dayjs(currentDate).isAfter(event.date, 'day') ||
        dayjs(currentDate).isSame(event.date, 'day')
    )
    .sort((a, b) => dayjs(a.date).diff(dayjs(b.date)));

  const upcomingEvents = events
    .filter((event) => dayjs(currentDate).isBefore(event.date, 'day'))
    .sort((a, b) => dayjs(a.date).diff(dayjs(b.date)));
  const event =
    upcomingEvents.length > 0
      ? upcomingEvents[0]
      : previousEvents[previousEvents.length - 1];
  const { slug } = event;

  useFriendlyViewPort();
  useViewportSizeTracking();
  return (
    <div>
      <div
        id={slug}
        className="items-center justify-center w-full no-transition-on-load transition-bg-1s "
      >
        <div>
          <EventOverviewComponent events={events} withPageHeader />
        </div>
      </div>
    </div>
  );
};

export default Event;
